import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RequisitionModalComponent } from '../../../shared/modals/requisition-modal/requisition-modal.component';

@Injectable({
  providedIn: 'root'
})
export class RequisitionModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: any, templateId?: string, activeTab?: number, price?: number) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( RequisitionModalComponent, {windowClass : "myCustomModalClassUnderTopBar", size: 'xxl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.model = model;
    modalRef.componentInstance.documentTemplateId = templateId;
    modalRef.componentInstance.activeTab = activeTab;
    if(price){
      modalRef.componentInstance.priceTotal = price;
    }
    modalRef.result.then(() => {
        this.modelChanged.emit(true);
        modalRef.componentInstance.ngOnDestroy();
      });
  }
}
